// // src/components/login/Login.js

// import React, { useState } from 'react';
// import axios from '../../axiosConfig'; // Import configured Axios instance
// import './Login.css';

// const Login = () => {
//     const [formData, setFormData] = useState({
//         email: '',
//         password: '',
//     });

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData((prevFormData) => ({
//             ...prevFormData,
//             [name]: value,
//         }));
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         try {
//             const response = await axios.post('/login', {
//                 email: formData.email,
//                 password: formData.password,
//             });

//             const { token } = response.data;
//             localStorage.setItem('jwtToken', token);

//             const { userRole } = response.data;
//              localStorage.setItem('userRole', userRole);

//             if (response?.data?.success) {
//                 alert('Login successful!');
//                 setFormData({ email: '', password: '' });
//                 window.location.href = '/';
//             }
//         } catch (error) {
//             alert(error?.response?.data?.message || 'Login failed. Please try again.');
//         }
//     };

//     return (
//         <div className="login-container">
//             <h2>Login</h2>
//             <form onSubmit={handleSubmit} className="login-form">
//                 <div>
//                     <label>Email</label>
//                     <input
//                         type="email"
//                         name="email"
//                         value={formData.email}
//                         onChange={handleChange}
//                     />
//                 </div>
//                 <div>
//                     <label>Password</label>
//                     <input
//                         type="password"
//                         name="password"
//                         value={formData.password}
//                         onChange={handleChange}
//                     />
//                 </div>
//                 <button type="submit" className="login-btn">Login</button>
//             </form>
//         </div>
//     );
// };

// export default Login;



// src/components/login/Login.js

// import React, { useState } from 'react';
// import axios from '../../axiosConfig'; // Import configured Axios instance
// import './Login.css';

// const Login = () => {
//     const [formData, setFormData] = useState({
//         email: '',
//         password: '',
//     });

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData((prevFormData) => ({
//             ...prevFormData,
//             [name]: value,
//         }));
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         // ✅ Basic validation
//         if (!formData.email.trim() || !formData.password.trim()) {
//             alert("Both email and password are required!");
//             return;
//         }

//         // ✅ Validate email format
//         const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//         if (!emailPattern.test(formData.email)) {
//             alert("Please enter a valid email address.");
//             return;
//         }

//         try {
//             const response = await axios.post('/login', {
//                 email: formData.email,
//                 password: formData.password,
//             });

//             if (response?.data?.success) {
//                 const { token, userRole } = response.data;

//                 // ✅ Store user session details securely
//                 localStorage.setItem('jwtToken', token);
//                 localStorage.setItem('userRole', userRole);

//                 alert('Login successful!');
//                 setFormData({ email: '', password: '' });
//                 window.location.href = '/';
//             }
//         } catch (error) {
//             alert(error?.response?.data?.message || 'Login failed. Please try again.');
//         }
//     };

//     return (
//         <div className="login-container">
//             <h2>Login</h2>
//             <form onSubmit={handleSubmit} className="login-form">
//                 <div>
//                     <label>Email</label>
//                     <input
//                         type="email"
//                         name="email"
//                         value={formData.email}
//                         onChange={handleChange}
//                         required
//                     />
//                 </div>
//                 <div>
//                     <label>Password</label>
//                     <input
//                         type="password"
//                         name="password"
//                         value={formData.password}
//                         onChange={handleChange}
//                         required
//                     />
//                 </div>
//                 <button type="submit" className="login-btn">Login</button>
//             </form>
//         </div>
//     );
// };

// export default Login;

// src/components/login/Login.js

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from '../../axiosConfig';
import './Login.css';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import wakeServer from '../../utils/wakeServer';
import { GoogleLogin } from '@react-oauth/google';

const Login = () => {
    const [formData, setFormData] = useState({
        email: '',
        password: '',
    });
    const [showPassword, setShowPassword] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
    };

    const handleGoogleSuccess = async (credentialResponse) => {
        try {
            const response = await axios.post('/auth/google', {
                credential: credentialResponse.credential,
            });

            if (response?.data?.success) {
                const { token, userRole } = response.data;
                localStorage.setItem('jwtToken', token);
                localStorage.setItem('userRole', userRole);
                toast.success('Google login successful!');
                window.location.href = '/';
            } else {
                toast.error(response?.data?.message || 'Google sign-in failed');
            }
        } catch (error) {
            console.error('Google Login Error:', error);
            toast.error(error?.response?.data?.message || 'Google sign-in failed. Please try again.');
        }
    };

    const handleGoogleError = () => {
        toast.error('Google sign-in could not be completed. Add your app URL to the Authorized JavaScript origins in Google Cloud Console, such as http://localhost:3000 and https://www.ambitionjet.com.');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.email.trim() || !formData.password.trim()) {
            toast.error('Both email and password are required.');
            return;
        }

        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(formData.email)) {
            toast.error('Please enter a valid email address.');
            return;
        }

        setIsSubmitting(true);
        try {
            toast.info('Checking server status...');
            const serverReady = await wakeServer();

            if (!serverReady) {
                toast.error('Server is starting. Please try again in a moment.');
                return;
            }

            const response = await axios.post('/login', {
                email: formData.email,
                password: formData.password,
            });

            if (response?.data?.success) {
                const { token, userRole } = response.data;
                localStorage.setItem('jwtToken', token);
                localStorage.setItem('userRole', userRole);
                toast.success('Login successful!');
                setFormData({ email: '', password: '' });
                window.location.href = '/';
            } else {
                toast.error(response?.data?.message || 'Invalid credentials');
            }
        } catch (error) {
            console.error('Login Error:', error);
            toast.error(error?.response?.data?.message || 'Invalid credentials');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="auth-page">
            <div className="auth-card">
                <div className="auth-header">
                    <h2>Welcome back</h2>
                    <p>Sign in to continue reading and publishing blogs.</p>
                </div>

                <div className="auth-social">
                    <GoogleLogin
                        onSuccess={handleGoogleSuccess}
                        onError={handleGoogleError}
                        text="continue_with"
                        shape="rectangular"
                        width="100%"
                    />
                </div>

                <div className="auth-divider">
                    <span>or sign in with email</span>
                </div>

                <form onSubmit={handleSubmit} className="auth-form">
                    <div className="form-field">
                        <label>Email address</label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="you@example.com"
                            required
                        />
                    </div>

                    <div className="form-field">
                        <label>Password</label>
                        <div className="password-field">
                            <input
                                type={showPassword ? 'text' : 'password'}
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                placeholder="Enter your password"
                                required
                            />
                            <button
                                type="button"
                                className="password-toggle"
                                onClick={() => setShowPassword((prev) => !prev)}
                            >
                                {showPassword ? 'Hide' : 'Show'}
                            </button>
                        </div>
                    </div>

                    <button type="submit" className="auth-btn" disabled={isSubmitting}>
                        {isSubmitting ? 'Signing in...' : 'Sign in'}
                    </button>
                </form>

                <p className="auth-footer">
                    Don’t have an account? <Link to="/signup">Create one</Link>
                </p>
            </div>
        </div>
    );
};

export default Login;
